<template>
    <Select
        :model-value="selectedTeamId"
        @update:model-value="(id) => selectUser(id)"
    >
        <SelectTrigger>
            <SelectValue class="px-2" :placeholder="$t('bookings.by_team')" />
        </SelectTrigger>
        <SelectContent>
            <SelectGroup>
                <SelectItem class="gap-3 px-4" value="all">
                    {{ $t("team_reports.all_members") }}</SelectItem
                >
                <SelectItem
                    v-for="team of teamMembers"
                    :key="team.id"
                    class="gap-3 px-4"
                    :value="team.id.toString()"
                >
                    {{ team.name }}
                </SelectItem>
            </SelectGroup>
        </SelectContent>
    </Select>
</template>

<script setup lang="ts">
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";

import { ref } from "vue";

import { User } from "../../EventTypes/types/EventType";

const props = defineProps<{
    teamMembers: User[];
    selectedTeamMember?: User;
}>();
const emit = defineEmits(["selectUser"]);
const selectedTeamId = ref<string>(
    props.selectedTeamMember?.id.toString() || "all",
);

function selectUser(userId: string) {
    if (userId === "all") {
        emit("selectUser", undefined);
    } else {
        emit(
            "selectUser",
            props.teamMembers.find((u) => u.id === parseInt(userId)),
        );
    }
    selectedTeamId.value = userId.toString();
}
</script>
